import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons'
import { FormatISODateTime } from '../../../helpers/formatting'

function eventReason(event) {
  const meta = event.meta ?? {}
  if (event.event === 'apply_failed') {
    if (meta.error_codes?.length > 0) return meta.error_codes.join(', ')
    return meta.error ?? null
  }
  if (event.event === 'cache_clear_failed' && meta.status) {
    return `HTTP ${meta.status}`
  }
  return null
}

export default function ChangeRequestDiscussion({
  events,
  canComment,
  isBusy,
  onComment,
}) {
  const [comment, setComment] = useState('')
  const post = () => {
    onComment(comment).then((ok) => ok && setComment(''))
  }

  return (
    <div data-testid="cr-discussion">
      {events.length > 0 && (
        <ol className="lox-cr-review__timeline">
          {events.map((event) => {
            const reason = eventReason(event)
            return (
              <li key={event.id} className="lox-cr-review__timeline-item">
                <span
                  className="lox-cr-review__timeline-dot"
                  aria-hidden="true"
                />
                <p>
                  <strong>{event.event.replaceAll('_', ' ')}</strong>
                  <span className="has-text-grey">
                    {' '}
                    · {event.user_name ?? 'System'} ·{' '}
                    {FormatISODateTime(event.created_at)}
                  </span>
                </p>
                {reason && (
                  <p
                    className="is-size-7 has-text-danger"
                    data-testid="cr-event-reason"
                  >
                    {reason}
                  </p>
                )}
                {event.comment && (
                  <p className="lox-cr-review__timeline-comment">
                    {event.comment}
                  </p>
                )}
              </li>
            )
          })}
        </ol>
      )}
      {canComment && (
        <div className="lox-cr-review__comment-box">
          <textarea
            className="textarea"
            rows={3}
            placeholder="Add a comment..."
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            data-testid="cr-discussion-text"
          />
          <button
            type="button"
            className="button is-primary is-small"
            disabled={isBusy || comment.trim() === ''}
            onClick={post}
            data-testid="cr-discussion-post"
          >
            <FontAwesomeIcon icon={faCommentDots} className="mr-1" />
            Comment
          </button>
        </div>
      )}
    </div>
  )
}
